import { connect } from 'react-redux';
import { getGuid } from '@marmalade/account/lib/selectors';

const withGUID = Component =>
    connect(state => ({
        guid: getGuid(state),
    }))(Component);

export default withGUID;
